import { render, staticRenderFns } from "./Jxlb.vue?vue&type=template&id=633c4b84&"
import script from "./Jxlb.vue?vue&type=script&lang=js&"
export * from "./Jxlb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports